import { createBrowserClient } from "@supabase/ssr";
import { getWidgetBaseUrl } from "./origin";

let client: ReturnType<typeof createBrowserClient> | null = null;

function buildCookieOptions() {
  const isSubmagic = new URL(getWidgetBaseUrl()).hostname.endsWith(
    ".submagic.co"
  );
  return {
    ...(isSubmagic ? { domain: ".submagic.co" } : {}),
    sameSite: "lax" as const,
    secure: isSubmagic,
    path: "/",
  };
}

export function getSupabase() {
  if (!client) {
    client = createBrowserClient(
      process.env.NEXT_PUBLIC_SUPABASE_URL!,
      process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!,
      {
        auth: { persistSession: true },
        cookieOptions: buildCookieOptions(),
      }
    );
  }
  return client;
}

// Returns true when a sign-in happened (and consumed the captcha token).
export async function signInAnonymouslyIfNeeded(
  captchaToken: string
): Promise<boolean> {
  const supabase = getSupabase();
  const { data } = await supabase.auth.getSession();
  if (data.session) return false;
  const { error } = await supabase.auth.signInAnonymously({
    options: { captchaToken },
  });
  if (error) throw new Error(`Anonymous sign-in failed: ${error.message}`);
  return true;
}

// Turnstile tokens are single-use: a sign-in consumes one, so the upload needs a fresh one.
export async function authenticateForUpload(
  getToken: () => Promise<string>
): Promise<string> {
  const token = await getToken();
  const signedIn = await signInAnonymouslyIfNeeded(token);
  return signedIn ? getToken() : token;
}
